<template>
	<tabbed-page-layout class="fleet" title="Flåde" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>